import type {SalesRepository} from '../repository/SalesRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import type {Sale} from '../models/sale.model';

export class GetSaleByIdUseCase {
  constructor (private salesRepository: SalesRepository) {}

  async execute (id: string): Promise<BaseResponse<Sale>> {
    return await this.salesRepository.getSaleById(id);
  }
}
